import { createSlice } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

const initialState = {
	vacancy:{},
	vacancyId:null,
	reload: true,
}
const VacancySlice = createSlice({
	name: "vacancy",
	initialState,
	reducers: {
		refresh(state) {
			state.reload = !state.reload
		},		
		setVacancy(state, action) {
			state.vacancy = action.payload
		},
		setVacancyId(state, action) {
			state.vacancyId = action.payload
		},
	},
})

export default VacancySlice

/**
 * Hook para obtener el estado del PerfilesPuesto desde Redux.
 *
 * @returns {{reload: boolean, vacancyId: int,vacancy:object}}
 * @property {boolean} reload - Indica si se debe recargar el PerfilesPuesto.
 * @property {int} vacancyId 
 * @property {object} vacancy 
 */
export const useVacanteRedux = () => {
	return useSelector((state) => state.vacancy)
}
